import type {ReactElement} from 'react';
import {useState} from 'react';
import {FormMakerMobileControlSheet} from '@FormMakerReact/components/form-maker-mobile-control-sheet/form-maker-mobile-control-sheet';
import {formMakerContext} from '@FormMakerReact/form-maker.context';
import type {FormMakerProps} from '@FormMakerReact/form-maker.types';
import {useFormMakerContextState} from '@FormMakerReact/hooks/use-form-maker-context-state';
import {FormMakerLayout} from '@FormMakerReact/layout/form-maker-layout/form-maker-layout';

export function FormMaker({store}: FormMakerProps): ReactElement {
  const [canvasContainer, setCanvasContainer] = useState<HTMLElement | null>(null);
  const ctx = useFormMakerContextState({store, canvasContainer});

  return (
    <formMakerContext.Provider value={ctx}>
      <FormMakerLayout onCanvasContainerReady={setCanvasContainer} />
      <FormMakerMobileControlSheet />
    </formMakerContext.Provider>
  );
}
